import { useState } from "react";
import { useRouter } from "next/navigation";
import { deleteCookie } from "cookies-next";
import useProfileStore from "@/store/useProfileStore";
import { COOKIE_CONFIG } from "@/config";
import { showToast, TOAST_TYPES } from "@/lib/toast-utils/toast.util";
import { useQueryClient } from "@tanstack/react-query";

export const useProfileDropdown = () => {
  const router = useRouter();
  const queryClient = useQueryClient();

  const [isMounted] = useState<boolean>(() => typeof window !== "undefined");
  const { profileData, clearProfile } = useProfileStore();

  const logout = () => {
    localStorage.clear();
    deleteCookie(COOKIE_CONFIG.loggedIn);
    deleteCookie(COOKIE_CONFIG.profile);
    deleteCookie(COOKIE_CONFIG.version);
    clearProfile();
    showToast(TOAST_TYPES.success, "Logged out successfully");
    // Clear the cache immediately
    queryClient.clear();
    // This prevents back button from navigating to previous pages
    if (typeof window !== "undefined") {
      window.location.replace("/login");
    } else {
      router.replace("/login");
    }
  };

  const changeRoute = (route: string) => {
    router.push(route);
  };

  return {
    isMounted,
    profileData,
    logout,
    changeRoute,
  };
};
